module.exports = __webpack_public_path__ + "static/iconography-metaphor-dont-746b91a734e21d7c11f66f39a4ea5702.png";